module.exports = __webpack_public_path__ + "static/media/ImporterFeature2.040c7e45.svg";